import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const { FiPhone, FiMail, FiMapPin, FiClock, FiSend } = FiIcons;
const { FaWhatsapp, FaFacebook } = FaIcons;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Service Inquiry: ${formData.service}`;
    const body = `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nService: ${formData.service}\n\nMessage:\n${formData.message}`;
    const mailtoLink = `mailto:Apex.Aerials@aol.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const whatsappUrl = "https://wa.me/447734253236";
  const facebookUrl = "https://www.facebook.com/share/1Am41wyJwq/";

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Get In Touch</h2>
          <div className="w-24 h-1 bg-red-600 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to improve your TV reception? Contact us for a free quote and consultation
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
            
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-10 h-10 bg-green-500 rounded flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FaWhatsapp} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">WhatsApp</h4>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-green-600 break-all text-sm">07734253236</a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-10 h-10 bg-blue-600 rounded flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FaFacebook} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">Facebook</h4>
                  <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-blue-600 text-sm">Follow Page</a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-10 h-10 bg-red-600 rounded flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">Mobile (24/7)</h4>
                  <a href="tel:07734253236" className="text-gray-600 hover:text-red-600 text-sm">07734253236</a>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
                <div className="w-10 h-10 bg-blue-900 rounded flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">Office</h4>
                  <a href="tel:01617945556" className="text-gray-600 hover:text-blue-900 text-sm">0161 794 5556</a>
                </div>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg">
              <div className="w-10 h-10 bg-gray-800 rounded flex items-center justify-center flex-shrink-0">
                <SafeIcon icon={FiMail} className="w-6 h-6 text-white" />
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 text-sm">Email</h4>
                <a href="mailto:Apex.Aerials@aol.com" className="text-gray-600 hover:text-blue-600 text-sm">Apex.Aerials@aol.com</a>
              </div>
            </div>

            <div className="pt-6">
              <h4 className="font-semibold text-gray-900 mb-4">Quick Connect</h4>
              <div className="flex flex-wrap gap-3">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg font-bold transition-all flex items-center gap-2 shadow-md">
                  <SafeIcon icon={FaWhatsapp} className="w-5 h-5" /> WhatsApp
                </a>
                <a href={facebookUrl} target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-bold transition-all flex items-center gap-2 shadow-md">
                  <SafeIcon icon={FaFacebook} className="w-5 h-5" /> Facebook
                </a>
              </div>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="bg-gray-50 p-8 rounded-xl shadow-inner border border-gray-100"
          >
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Request a Quote</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <input type="text" name="name" placeholder="Full Name *" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-transparent outline-none transition-all" />
                <input type="tel" name="phone" placeholder="Phone Number *" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-transparent outline-none transition-all" />
              </div>
              <input type="email" name="email" placeholder="Email Address *" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-transparent outline-none transition-all" />
              <select name="service" value={formData.service} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-transparent outline-none transition-all">
                <option value="">Select Service</option>
                <option value="Aerial Installation">Aerial Installation</option>
                <option value="Satellite Installation">Satellite Installation</option>
                <option value="TV Wall Mounting">TV Wall Mounting</option>
                <option value="Repairs">Repairs</option>
              </select>
              <textarea name="message" rows={4} placeholder="Your Message" value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-600 focus:border-transparent outline-none transition-all resize-none"></textarea>
              <button type="submit" className="w-full bg-red-600 hover:bg-red-700 text-white px-6 py-4 rounded-lg font-bold transition-all shadow-lg flex items-center justify-center gap-2">
                <SafeIcon icon={FiSend} className="w-5 h-5" /> Send Message
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;